module.exports = __webpack_public_path__ + "media/images/lb/217-7360138eefe0860050133c925d112e83.svg";